import Grid from '@mui/material/Grid';
import { useToastProvider } from '../../shared/ToastProvider';
import { useEffect } from 'react';
import { FileUploadCard } from '../../shared/FileUploadCard';
import { LinkInputForm } from './LinkInputForm';
import { useDispatch, useSelector } from 'react-redux';
import {
  clearLinksModalMessages,
  fetchCreateLink,
  fetchLinks
} from './linksSlice';
import { PHASE_NAME_VALUE_MAP } from '../../shared/AppConstants';
import { PhaseLinksList } from './PhaseLinksList';
import { ErrorBanner } from './ErrorBanner';

export function PhaseLinks({ userInfoMap }) {
  const dispatch = useDispatch();
  const strategyNumber = useSelector((state) => state.phases.strategyNumber);
  const { enqueueToast } = useToastProvider();
  const createErrorMessage = useSelector(
    (state) => state.links.createErrorMessage
  );

  const onSave = (data, _, clearComponent) => {
    dispatch(
      fetchCreateLink({
        url: data.formValues.link,
        description: data.description,
        ...data.selectedPhases.reduce((result, phase) => {
          result[PHASE_NAME_VALUE_MAP[phase]] = true;
          return result;
        }, {})
      })
    ).then((response) => {
      if (response.type === 'links/create/fulfilled') {
        clearComponent();
        enqueueToast({
          variant: 'success',
          message: 'Link created successfully'
        });
      }
    });
  };

  const links = useSelector((state) => state.links.links);

  useEffect(() => {
    if (strategyNumber) dispatch(fetchLinks());
  }, [strategyNumber]);

  return (
    <Grid mt={4}>
      <ErrorBanner errorMessage={createErrorMessage} />
      <FileUploadCard
        title={'Relevant Links'}
        entity={'link'}
        VariableForm={LinkInputForm}
        variableFormProps={{ name: 'link' }}
        onSave={onSave}
        commonProps={{
          clearAllMessages: () => dispatch(clearLinksModalMessages())
        }}
        count={Object.keys(links).length}
        additionalContent={
          <PhaseLinksList linkData={links} userInfoMap={userInfoMap} />
        }
      />
    </Grid>
  );
}
